export class MessageRoutes
{
    static Home: string = "/";
    static MessageList: string = `/message/list`;
    static MessageView(id: string)
    {
        return `/message/${id}/view`;
    }
}